export function get_office_types_array () {
    return [
        {
            id:0,
            type: 'pet sitter',
            img_source: require('@/assets/card_pet_sitter_200.jpg')
        },
        {
            id:1,
            type: 'therapy salon',
            img_source: require('@/assets/card_therapy_200.jpg')
        },
        {
            id:2,
            type: 'beauty salon',
            img_source: require('@/assets/card_cosmetics_200.jpg')
        },
        {
            id:3,
            type: 'medical office',
            img_source: require('@/assets/card_medical_office_200.jpg')
        },
        {
            id:4,
            type: 'administrative docs',
            img_source: require('@/assets/card_admin_office_200.jpg')
        },
        {
            id:5,
            type: 'barber shop',
            img_source: require('@/assets/card_barber_shop_200.jpg')
        },
        {
            id:6,
            type: 'pet grooming',
            img_source: require('@/assets/card_pet_grooming_200.jpg')
        },
        {
            id:7,
            type: 'sport center',
            img_source: require('@/assets/card_sport_center_200.jpg')
        },
    ]
}